export default {
	back_home: '返回首页',
	buy_now: '立即购买',
	data_disk: '数据盘',
	empty: '暂无产品',
	invoice_not_found: '发票不存在或链接已失效',
	package: '套餐',
	per_month: '/月',
	server_desc: '专用物理硬件，性能高，带宽大，可加IP',
	server_title: '独立物理服务器',
	system_disk: '系统盘',
	vps_desc: '高性能，高可用，高性价比',
	vps_title: 'VPS云服务器',
}
